import { call, put, takeLatest } from "redux-saga/effects";
import { GET_BoardColumns, POST_BoardMove } from "../services/Board";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_BoardColumnsEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_BoardColumns, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_BoardColumns", payload: resData.data });
    if (callback) callback(resData.data);
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_BoardMoveEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(POST_BoardMove, token, payload);
    if (res) { /* 無需解碼 */ }
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* BoardSaga() {
  yield takeLatest("GET_BoardColumns", GET_BoardColumnsEffect);
  yield takeLatest("POST_BoardMove", POST_BoardMoveEffect);
}
